import axios from 'axios';
import { API } from './index';
const pending = new Map();
const auth = () => ({ auth: JSON.parse(localStorage.getItem('admin_credentials') || '{}') });
export const inventoryGet = async (path, params={}) => (await axios.get(`${API}/admin/inventory/${path}`, {...auth(),params})).data;
export const inventoryAction = async (name,data,{operationId}={}) => {
  const key=JSON.stringify([name,data]);
  if(!pending.has(key)) pending.set(key,crypto.randomUUID());
  try { const result=(await axios.post(`${API}/admin/inventory/actions/${name}`,{operation_id:operationId||pending.get(key),data},auth())).data; pending.delete(key);return result; }
  catch(e){if(e.response && e.response.status<500)pending.delete(key);throw e;}
};
export const inventoryLabels = async data => (await axios.post(`${API}/admin/inventory/labels/preview`,data,auth())).data;
export const inventoryQuote = async items => (await axios.post(`${API}/inventory/quote`,{items:items.map(i=>({product_id:i.product_id||i.id,size:i.size,quantity:i.quantity}))})).data;
export const invError = e => typeof e.response?.data?.detail==='string' ? e.response.data.detail : 'Не удалось выполнить действие. Проверьте поля и подключение.';
